import { useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Box,
  Typography,
  Card,
  CardContent,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/axiosInstance";

export default function ResetPassword() {
  const navigate = useNavigate();

  const token = localStorage.getItem("token");

  const baseUrl = import.meta.env.VITE_BASE_URL;
  const [formValues, setFormValues] = useState({
    oldPassword: "",
    password: "",
    confirmPassword: "",
  });
  const { oldPassword, password } = formValues;
  const [showPassword, setShowPassword] = useState(false);

  const [formErrors, setFormErrors] = useState({
    oldPassword: "",
    password: "",
    confirmPassword: "",
  });

  const validate = () => {
    let errors = {};

    if (!formValues.oldPassword) {
      errors.oldPassword = "Old Password is required";
    }

    if (!formValues.password) {
      errors.password = "Password is required";
    } else if (formValues.password.length < 6) {
      errors.password = "Password must be at least 6 characters long";
    }

    if (!formValues.confirmPassword) {
      errors.confirmPassword = "Confirm Password is required";
    } else if (formValues.confirmPassword !== formValues.password) {
      errors.confirmPassword = "New Passwords do not match";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      ResetApi();
    }
  };

  const ResetApi = async () => {
    try {
      const url1 = `/reset_password`;
      // const url1 = `${baseUrl}/reset_password`;
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };
      const response = await axiosInstance.post(
        url1,
        { old_password: oldPassword, new_password: password },
        // { headers }
      );
      // const response = await axios.post(
      //   url1,
      //   { old_password: oldPassword, new_password: password },
      //   { headers }
      // );
      if (response.data.message == "Password reset successfully") {
        toast.success(response.data.message);
        localStorage.removeItem("token");
        setTimeout(() => {
          navigate("/login");
        }, 1000);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  return (
    <>
     {/*  */}
      <Card>
        <CardContent>
          <Box sx={{ maxWidth: 400, mx: "auto", my: "2.6rem" }}>
            <Typography variant="h5" align="center" gutterBottom>
              Reset Password
            </Typography>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Old Password"
                    name="oldPassword"
                    type="password"
                    value={formValues.oldPassword}
                    onChange={handleChange}
                    error={!!formErrors.oldPassword}
                    helperText={formErrors.oldPassword}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="New Password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    value={formValues.password}
                    onChange={handleChange}
                    error={!!formErrors.password}
                    helperText={formErrors.password}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleClickShowPassword}
                            edge="end"
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Confirm Password"
                    name="confirmPassword"
                    type="password"
                    value={formValues.confirmPassword}
                    onChange={handleChange}
                    error={!!formErrors.confirmPassword}
                    helperText={formErrors.confirmPassword}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                  >
                    Reset Password
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </CardContent>
      </Card>
    </>
  );
}
